import { makeStyles, Theme } from '@material-ui/core/styles';

import { baseFormStyles } from 'assets/styles/components/Form.styles';

const useStyles = makeStyles((theme: Theme) => ({
  ...baseFormStyles(theme),
  container: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
